import gql from "graphql-tag";

export const CHATS_QUERY = gql`
  query chats(
    $name: String
    $primaryClassification: String
    $secondaryClassification: String
    $after: String
    $hasMessages: Boolean
  ) {
    chats(
      name: $name
      primaryClassification: $primaryClassification
      secondaryClassification: $secondaryClassification
      first: 30
      after: $after
      hasMessages: $hasMessages
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          jid
          name
          primaryClassification
          secondaryClassification
          lastMessageTimestamp
          previousDayMessageCount
          previousWeekMessageCount
          previousDayPicCount
          previousWeekPicCount
        }
      }
    }
  }
`;

export const CHAT_QUERY = gql`
  query chat($chatId: ID!) {
    chat(chatId: $chatId) {
      id
      last3Messages {
        id
        text
        sentDate
        messagereactionSet {
          id
          reaction
          user {
            id
            firstName
            lastName
          }
        }
        messageattachmentSet {
          id
          type
          file
          timeInSeconds
          remoteFile
        }
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const CHAT_HISTORY = gql`
  query chatHistory($dateFrom: Date!) {
    chatHistory(dateFrom: $dateFrom) {
      date
      oneOnOneCount
      challengeCount
      lifeCount
      totalCount
      unclassifiedCount
    }
  }
`;

export const UPSERT_MESSAGE_MUTATION = gql`
  mutation upsertMessageMutation($data: MessageInput!) {
    upsertMessageMutation(data: $data) {
      success
      error
    }
  }
`;

export const CREATE_MESSAGE_ATTACHMENTS_MUTATION = gql`
  mutation createMessageAttachmentsMutation($data: CreateMessageAttachmentsInput!) {
    createMessageAttachmentsMutation(data: $data) {
      success
      errors
      attachmentIds
    }
  }
`;

export const CREATE_BULK_MESSAGE_MUTATION = gql`
  mutation createBulkMessageMutation($data: BulkMessageInput!) {
    createBulkMessageMutation(input: $data) {
      success
      error
      bulkMessage {
        id
        sender {
          id
          firstName
          lastName
        }
        scheduledAt
        sentAt
        messageText
        attachment
        attachmentType
        bulkmessagerecipientSet {
          id
          send
          lastCoachMessage {
            id
            sentDate
            text
            user {
              id
              firstName
              lastName
            }
          }
          recipient {
            id
            firstName
            lastName
            email
            username
            userProfile {
              id
              engagementScore
              rewardBalance
              phone
              activeSubscription {
                id
                product {
                  id
                  type
                }
                coach {
                  id
                  firstName
                  lastName
                }
              }
              lastWorkout {
                id
                date
                unitActivity {
                  id
                  title
                  activity {
                    id
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_BULK_MESSAGE_MUTATION = gql`
  mutation updateBulkMessageMutation($data: BulkMessageUpdateInput!) {
    updateBulkMessageMutation(input: $data) {
      success
      error
      requiresReload
      bulkMessage {
        id
        sender {
          id
          firstName
          lastName
        }
        scheduledAt
        sentAt
        messageText
        attachment
        attachmentType
        sendNotification
        bulkmessagerecipientSet {
          id
          send
          lastCoachMessage {
            id
            sentDate
            text
            user {
              id
              firstName
              lastName
            }
          }
          recipient {
            id
            firstName
            lastName
            email
            username
            userProfile {
              id
              engagementScore
              rewardBalance
              phone
              activeSubscription {
                id
                product {
                  id
                  type
                }
                coach {
                  id
                  firstName
                  lastName
                }
              }
              lastWorkout {
                id
                date
                unitActivity {
                  id
                  title
                  activity {
                    id
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const DELETE_BULK_MESSAGE_MUTATION = gql`
  mutation deleteBulkMessageMutation($bulkMessageId: ID!) {
    deleteBulkMessageMutation(bulkMessageId: $bulkMessageId) {
      success
    }
  }
`;

export const BULK_MESSAGE_QUERY = gql`
  query bulkMessage($bulkMessageId: ID!) {
    bulkMessage(bulkMessageId: $bulkMessageId) {
      id
      title
      sender {
        id
        firstName
        lastName
      }
      scheduledAt
      sentAt
      messageText
      attachment
      attachmentType
      filters
      sendNotification
      bulkmessagerecipientSet {
        id
        send
        lastCoachMessage {
          id
          sentDate
          text
          user {
            id
            firstName
            lastName
          }
        }
        recipient {
          id
          firstName
          lastName
          email
          username
          userProfile {
            id
            engagementScore
            rewardBalance
            phone
            activeSubscription {
              id
              product {
                id
                type
              }
              coach {
                id
                firstName
                lastName
              }
            }
            lastWorkout {
              id
              date
              unitActivity {
                id
                title
                activity {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const BULK_MESSAGES_QUERY = gql`
  query bulkMessages {
    bulkMessages {
      id
      title
      sender {
        id
        firstName
        lastName
      }
      scheduledAt
      sentAt
      messageText
      attachment
      attachmentType
      filters
      totalRecipients
      sendNotification
    }
  }
`;

export const CHATS_FOR_USER = gql`
  query chatsForUser(
    $type_In: [String]
    $userId: String
    $first: Int
    $after: String
    $search: String
    $onlyUnread: Boolean
    $orderBy: String
  ) {
    chatsForUser(
      type_In: $type_In
      userId: $userId
      first: $first
      after: $after
      search: $search
      onlyUnread: $onlyUnread
      orderBy: $orderBy
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          title
          description
          image
          type
        }
      }
    }
  }
`;

export const CHAT_REGISTRATIONS_QUERY = gql`
  query chatRegistrations($workoutBlockId: ID, $whatsappGroup_Id_Isnull: Boolean, $orderBy: String) {
    chatRegistrations(
      workoutBlock_Id: $workoutBlockId
      whatsappGroup_Id_Isnull: $whatsappGroup_Id_Isnull
      orderBy: $orderBy
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            email
            userProfile {
              id
              dateOfBirth
              engagementScore
              age
              currentBlocks {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const CHAT_REGISTRATIONS_OUTSTANDING_QUERY = gql`
  query chatRegistrationsOutstanding {
    chatRegistrationsOutstanding
  }
`;
